<template>
    <div :title="selectedName">
        <label for="region">Region</label>
            <div :class="[multipleOptions ? 'select' : 'one_option select']">
            <select id="region" v-model="selected">
                <option disabled="" value="default">Select a region</option>
                <option v-for="option in regions" v-bind:value="option.id">{{option.name}}</option>
            </select>
            <div class="select-styled-container"><div class="select-styled">{{selectedName}}</div></div>
        </div>
    </div>
</template>


<script>
import {mapActions, mapGetters} from 'vuex';
import URL from '@/util/url';
export default {
     data : function () {
        return {

        }
    },
    mounted(){
        //this.getData();
    },
    computed : {
        ...mapGetters([
            'regions',
            'region'
        ]),
         multipleOptions : function(){
            if(!this.regions){
                return;
            }

            if(! Array.isArray(this.regions)){
                return;
            }

            if(this.regions.length <= 1){
                return;
            }

            return true;

        },
        selectedName :function() {

            if(!this.regions){
                return;
            }

            let match = _.first(_.filter(this.regions, { id : this.selected }));

            if(!match){
                //return _.get(_.first(this.regions), "name");
                return "--";
            }

            return match.name;
        },
        selected : {
            get () {
                return this.region;
            },
            set (value) {
                this.setRegionState(value);
            }
        }
    },
    methods : {
        ...mapActions(
            [
                //'getData', //initial data from json
                'setRegionState'
            ]
        )
    },
    watch : {
        regions : function(){


            let match = _.find(this.regions, { id : URL.hash.location });

            if(match){
                this.setRegionState(match.id);
                return;
            }

            this.setRegionState( _.get(_.first(this.regions), "id") );
        }
    }
}
</script>